import { PaymentWorkflowState } from "@/store/PaymentWorkflow/state";

export class State extends PaymentWorkflowState {}
